import request from '@/utils/changanRequest'
// 便民资讯
export function trealinfoPage (query) {
  return request({
    url: 'system/trealinfo/wechat/list',
    method: 'get',
    params: query
  })
}
// 便民资讯详情
export function trealinfoDetails (query) {
  return request({
    url: '/system/trealinfo/wechat/details',
    method: 'get',
    params: query
  })
}
// 便民资讯分类
export function GetInfoKindInfoPage(params) {
  return request({
    url: "system/tinfokind/wechat/list",
    method: "get",
    params,
  });
}
// 保存社区动态
export const SaveRlInfo = (data) => {
  return request({
    url: 'system/trealinfo',
    method: 'post',
    data
  })
}
// 人员查询
export function GeUserList(params) {
  return request({
    url: "system/tmember/wechat/list",
    method: "get",
    params,
  });
}

//商家资讯详情查询
export function merchantActivity (id) {
  return request({
    url: '/system/merchantActivity/wechat/'+id,
    method: 'get',
  })
}
//商家活动详情查询
export function merchantInformation (id) {
  return request({
    url: '/system/merchantInformation/wechat/'+id,
    method: 'get'
  })
}
//商家广告查询
export function merchantAdvertisement (query) {
  return request({
    url: '/system/merchantAdvertisement/wechat/list',
    method: 'get',
    params: query
  })
}
//商家广告详情查询
export function merchantAdvertisementDetail (id) {
  return request({
    url: '/system/merchantAdvertisement/wechat/'+id,
    method: 'get'
  })
}
